import React, { useEffect, useRef, useState } from "react";
import SteppedNumberInput from "../../Reusable/NumberInputs/SteppedNumberInput";

function CommitOnBlurNumberInput({ value, onCommit, onCancel, ...inputProps }) {
  const [inputValue, setInputValue] = useState(value !== undefined ? String(value) : "");
  const [lastValidValue, setLastValidValue] = useState(value !== undefined ? String(value) : "");
  const inputRef = useRef(null);

  useEffect(() => {
    if (document.activeElement === inputRef.current) {
      return;
    }

    const nextValue = value !== undefined ? String(value) : "";
    setInputValue(nextValue);
    setLastValidValue(nextValue);
  }, [value]);

  const isTransientValue = (nextValue) => ["", "-", ".", "-."].includes(nextValue);

  const handleChange = (e) => {
    const nextValue = e.target.value;

    if (isTransientValue(nextValue) || !isNaN(Number(nextValue))) {
      setInputValue(nextValue);
    }
  };

  const commitValue = () => {
    if (isTransientValue(inputValue) || isNaN(Number(inputValue))) {
      setInputValue(lastValidValue);
      if (typeof onCancel === "function") {
        onCancel();
      }
      return;
    }

    const parsedValue = Number(inputValue);
    const normalizedValue = String(parsedValue);
    setInputValue(normalizedValue);
    setLastValidValue(normalizedValue);

    if (typeof onCommit === "function") {
      onCommit(parsedValue);
    }
  };

  const handleBlur = () => {
    commitValue();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (inputRef.current) {
        inputRef.current.blur();
      }
    } else if (e.key === "Escape") {
      setInputValue(lastValidValue);
      if (typeof onCancel === "function") {
        onCancel();
      }
    }
  };

  return (
    <SteppedNumberInput
      {...inputProps}
      ref={inputRef}
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
}

export default CommitOnBlurNumberInput;
